import { Signal, signal } from "@angular/core";

export namespace SignalUtil {
    export type FromPromise<T> = {
        isLoading: Signal<boolean>;
        value: Signal<T | undefined>;
        error: Signal<Error | undefined>;
    };
    export function fromPromise<T>(promise: Promise<T>): FromPromise<T> {
        const isLoading = signal(true);
        const value = signal<T | undefined>(undefined);
        const error = signal<Error | undefined>(undefined);

        promise
            .then(
                (val) => value.set(val),
                (err) => error.set(err),
            )
            .finally(() => isLoading.set(false));

        return {
            isLoading,
            value,
            error,
        };
    }
}
